/* lecteur-vitale.fr : panier (API AJAX Shopify), tiroir panier, animations au défilement, cartes cliquables */
(function () {
  if (window.LV) return;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = window.LV_CFG || {};
  var FREE = (cfg.free || 99) * 100;
  var money = function (c, cur) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur || 'EUR', minimumFractionDigits: c % 100 ? 2 : 0 }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function badge(n) {
    document.querySelectorAll('[data-lv-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* Tiroir */
  var bg, dr;
  function ensure() {
    if (dr) return;
    bg = document.createElement('div'); bg.className = 'lvd-bg';
    dr = document.createElement('aside'); dr.className = 'lvd'; dr.setAttribute('aria-label', 'Panier'); dr.setAttribute('role', 'dialog');
    document.body.appendChild(bg); document.body.appendChild(dr);
    bg.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function close() { if (!dr) return; bg.classList.remove('on'); dr.classList.remove('on'); }
  function open(cart, added, err) {
    ensure();
    var tot = cart.total_price, cur = cart.currency;
    dr.innerHTML = '<div class="lvd-h"><b>Votre panier (' + cart.item_count + ')</b><button class="lvd-x" type="button" aria-label="Fermer">×</button></div>' +
      (added ? '<div class="lvd-ok">✓ ' + (added.quantity > 1 ? added.quantity + ' × ' : '') + esc(added.product_title) + ' ajouté au panier</div>' : '') +
      (err ? '<div class="lvd-err">' + esc(err) + '</div>' : '') +
      '<div class="lvd-list">' + (cart.items.length ? cart.items.map(function (l) {
        return '<a class="lvd-it" href="' + l.url + '"><img src="' + (l.image ? l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '') + '" alt=""><span><b>' + esc(l.product_title) + '</b><small>' + l.quantity + ' × ' + money(l.final_price, cur) + '</small></span><span class="p">' + money(l.final_line_price, cur) + '</span></a>';
      }).join('') : '<div class="lvd-empty">Votre panier est vide.</div>') + '</div>' +
      '<div class="lvd-f">' +
        '<div class="lvd-free">' + (tot >= FREE ? '✓ Livraison offerte sur cette commande' : 'Plus que ' + money(FREE - tot, cur) + ' pour la livraison offerte') + '<div class="tr"><i style="width:' + Math.min(100, tot / FREE * 100) + '%"></i></div></div>' +
        '<div class="lvd-tot"><span>Sous-total</span><span>' + money(tot, cur) + '</span></div>' +
        '<a class="lvd-btn g" href="' + root + 'cart">Voir le panier et commander</a>' +
        '<button class="lvd-btn o" type="button" data-close>Continuer mes achats</button>' +
      '</div>';
    $('.lvd-x', dr).onclick = close; $('[data-close]', dr).onclick = close;
    requestAnimationFrame(function () { bg.classList.add('on'); dr.classList.add('on'); });
  }

  function add(variant, qty, btn) {
    if (!variant) return Promise.resolve();
    if (btn) btn.disabled = true;
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) { return getCart().then(function (cart) { badge(cart.item_count); open(cart, res.items && res.items[0]); document.dispatchEvent(new CustomEvent('lv:cart', { detail: cart })); }); })
      .catch(function (e) { return getCart().then(function (cart) { open(cart, null, (e && (e.description || e.message)) || 'Impossible d\'ajouter ce produit.'); }); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  window.LV = { add: add, open: function () { getCart().then(function (c) { open(c); }); }, close: close, badge: badge, money: money, getCart: getCart };

  /* Boutons « ajouter au panier » : data-lv-add="ID variante", quantité éventuelle dans data-lv-qty="#selecteur" */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lv-add]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var q = 1, sel = b.getAttribute('data-lv-qty');
      if (sel) { var i = document.querySelector(sel); q = Math.max(1, parseInt(i && i.value, 10) || 1); }
      add(b.getAttribute('data-lv-add'), q, b);
      return;
    }
    var o = e.target.closest('[data-lv-open-cart]');
    if (o) { e.preventDefault(); window.LV.open(); return; }
    /* Toute la carte produit est cliquable (sauf boutons et liens) */
    if (e.target.closest('button, a, input, select, label, textarea')) return;
    var card = e.target.closest('[data-lv-href]');
    if (card) location.href = card.getAttribute('data-lv-href');
  });

  /* Apparitions au défilement */
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.lv-rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); x.target.dispatchEvent(new CustomEvent('lv:in')); io.unobserve(x.target); } }); }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  window.LV.reveal = reveal;
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
